import { render, staticRenderFns } from "./SimulatorsChat.vue?vue&type=template&id=2f581787&scoped=true"
import script from "./SimulatorsChat.vue?vue&type=script&lang=js"
export * from "./SimulatorsChat.vue?vue&type=script&lang=js"
import style0 from "./SimulatorsChat.vue?vue&type=style&index=0&id=2f581787&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f581787",
  null
  
)

export default component.exports